import axios from "axios";

export default {
  name: "reconciliation",
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getbanklist(store, { auth }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "bank_reconcile/data_input",
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    createReconcile(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url:
            process.env.VUE_APP_SERVICEURL + "bank_reconcile",
          data: params,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    editReconcile(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url:
            process.env.VUE_APP_SERVICEURL + "bank_reconcile/edit",
          data: params,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    cancelReconcile(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url:
            process.env.VUE_APP_SERVICEURL + "bank_reconcile/cancel",
          data: params,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deleteReconcile(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url:
            process.env.VUE_APP_SERVICEURL + "bank_reconcile/delete",
          data: params,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateDateBKKRealization(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url:
            process.env.VUE_APP_SERVICEURL + "bank_reconcile/ubah_tgl_realisasi_bkk",
          data: params,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    uploadLampiranReconcile(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url:
            process.env.VUE_APP_SERVICEURL + "bank_reconcile/upload_lampiran",
          data: params,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    RemoveuploadLampiranReconcile(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url:
            process.env.VUE_APP_SERVICEURL + "bank_reconcile/delete_lampiran",
          data: params,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getDataReconcile(store, { auth, id, periode }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "bank_reconcile",
          params: {
            bank_account_id: id,
            periode: periode
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getReconcilePeriode(store, { auth, param }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: process.env.VUE_APP_SERVICEURL + "bank_reconcile/set",
          data: {
            bank_account_id: param.id,
            tlc: param.tlc,
            periode: param.periode,
            start_balance: param.balance,
            saldo_acuan_realisasi: param.saldo,
            trans_date: param.trans_date
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    closeReconcile(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url:
            process.env.VUE_APP_SERVICEURL + "bank_reconcile/close_bank_reconcile",
          data: params,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    draftReconcile(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url:
            process.env.VUE_APP_SERVICEURL + "bank_reconcile/draft_bank_reconcile",
          data: params,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getDataEditReconcile(store, { auth, id }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "bank_reconcile/edit",
          params: {
            id: id,
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then(({ data }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
